<template>
  <div class="c-channels [ u-grid__item u-1/3@wide ]">
    <h3 class="o-heading c-channels__title">Of luister naar</h3>
    <div class="c-channels__list">
      <template v-if="visibleChannels.length">
        <ChannelListItem v-for="channel in visibleChannels" :key="channel.id" :channel="channel" />
      </template>
    </div>
    <a @click.prevent="openAllChannels()" href="#" class="c-button c-button--secondary c-button--wide c-button--small">
      {{ 'channel_list.show_full_list' | t }}
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { openPlayer } from '../../mixins/radioPlayer';
import ChannelListItem from './ChannelListItem';

const shortListCount = 4;

export default {
  name: 'ChannelList',
  mixins: [openPlayer],
  components: {
    ChannelListItem,
  },
  computed: {
    visibleChannels() {
      return this.channels.filter((channel) => channel.type === 'channel').slice(0, shortListCount);
    },
    ...mapState({
      channels: state => state.channels.channels,
      defaultChannel: state => state.stations.stationId,
    }),
  },
  mounted() {
    this.clearLastPlayed();
  }
};
</script>
